import { Injectable } from "@angular/core";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseBlotterDataAdapter } from "./BaseBlotterDataAdapter";
import { FindTradeTableDefinitionFactory } from "../../model/FindTradeTableDefinitionFactory";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class FindDealsDealAdapter extends BaseBlotterDataAdapter {
  constructor(protected _tableDefinitionFactory: FindTradeTableDefinitionFactory) {
    super(_tableDefinitionFactory);
  }
}
